import { user } from "src/components/login/login";
import Form from "../form";
export const items = [
    {title: "Individual Reporting", type: "text", required: true, default: user.userName}, 
    {title: "Date", type: "date", required: true}, 
    {title: "Location", type: "select", options: ["Hayward", "Sacramento", "Fremont", "Fresno"].map(item => ({label: item, value: item})), required: true}, 
    {title: "Signal obtained over facility", type: "select", options: ["Yes", "No"].map(item => ({label: item, value: item})), required: true},
    {title: "within 6\" of depth at midpoint", type: "select", options: ["Yes", "No"].map(item => ({label: item, value: item})), required: true},
    {title: "within 3\" of centerline", type: "select", options: ["Yes", "No"].map(item => ({label: item, value: item})), required: true},
    {title: "EMS if applicable", type: "select", options: ["Yes", "No", "N/A"].map(item => ({label: item, value: item})), required: true},
    {title: "Equipment", type: "select", options: ["RD", "Vivax", "Pipehorn"].map(item => ({label: item, value: item})), required: true}, 
    {title: "Transmitter", type: "text", required: true}, 
    {title: "Receiver", type: "text", required: true}, 
    {title: "Approver Notes"}
];
//--------------------------------------------------------------------------------------------
export default function CalibrationVerification({
    closeIt, 
    form, 
    picData, setPicData, 
    sketches, setSketches, 
    usersList, setUserList
}){
    //--------------------------------------------------------------------------------------------
    return(
        <Form
            closeIt = {closeIt}
            form = {form}
            picData = {picData}
            setPicData = {setPicData}
            sketches = {sketches}
            setSketches = {setSketches}
            usersList = {usersList}
            setUserList = {setUserList}

            items = {items}
        />
    )    
}